export const notifications = {
  leasing: [
    {
      event: "New rental applications are received",
      name: "isRntalApplictinRecved",
      email: true,
      mobilePush: false,
    },
    {
      event: "Online leases are ready for countersigning",
      name: "isOnlineLeasesReady",
      email: true,
      mobilePush: false,
    },
    {
      event: "A showing I'm assigned to is created, updated, or canceled",
      name: "assignedShowingUpdates",
      email: true,
      mobilePush: false,
    },
    {
      event: "New guest cards are received",
      name: "isReceivedGuestCards",
      email: true,
      mobilePush: false,
    },
  ],
  maintenance: [
    {
      event: "Resident creates a maintenance request",
      name: "rqstMaintenance",
      email: true,
      mobilePush: false,
    },
    {
      event: "Resident requests cancellation of a maintenance request",
      name: "rqstCancellation",

      email: true,
      mobilePush: false,
    },
    {
      event: "I am assigned to a work order",
      name: "assignedWorkOrder",

      email: true,
      mobilePush: true,
    },
    {
      event: "Vendor accepts a work order that I am tracking",
      name: "trackedAcceptance",

      email: true,
      mobilePush: true,
    },
    {
      event: "Vendor declines a work order that I am tracking",
      name: "vendorWorkOrderDecline",
      email: true,
      mobilePush: true,
    },
    {
      event: "Vendor schedules a time for a work order that I am tracking",
      name: "vendorScheduledTime",
      email: true,
      mobilePush: true,
    },
    {
      event: "Vendor submits or edits a note for a work order I am tracking",
      name: "vendorWorkOrderNote",

      email: true,
      mobilePush: true,
    },
    {
      event: "Vendor changes the status for a work order I am tracking",
      name: "vndorWrkOrdrStatusChnge",
      email: true,
      mobilePush: true,
    },
    {
      event:
        "Vendor submits or edits an estimate for a work order I am tracking",
      name: "vndorWrkOrdrEstimate",
      email: true,
      mobilePush: true,
    },
    {
      event:
        "Follow-up date has been reached on a work order that I am tracking",
      name: "workOrdrFllwUpRched",
      email: true,
      mobilePush: true,
    },
    {
      event: "When a tenant signs an inspection",
      name: "tenantInspctnSignd",
      email: true,
      mobilePush: false,
    },
    {
      event: "Inventory items reach their reorder quantity",
      name: "invntryReorderRched",
      email: true,
      mobilePush: false,
    },
  ],
  communication: [
    {
      event:
        "A new text is received from someone whom I was the last person to text",
      name: "lastCntctTxtRecved",
      email: true,
      mobilePush: true,
    },
  ],
  accounting: [
    {
      event: "Tenant online payments are rejected",
      name: "rejctdTenantPymnts",
      email: true,
      mobilePush: false,
    },
    {
      event: "Outbound eCheck payments are rejected",
      name: "rjctedOutboundECheck",
      email: true,
      mobilePush: false,
    },
    {
      event: "Owner contribution notifications",
      name: "ownerCntributionAlrts",
      email: true,
      mobilePush: false,
    },
    {
      event: "New Smart Bill Entry emailed invoices are received",
      name: "newSmartBillInvoices",
      email: true,
      mobilePush: false,
    },
    {
      event:
        "Bills are skipped from an Automated AP payment batch due to insufficient funds",
      name: "skippedBillsDueFunds",
      email: true,
      mobilePush: false,
    },
  ],
  associations: [
    {
      event:
        "New votes or comments are made on Association approvals I created",
      name: "approvalActivity",
      email: true,
      mobilePush: false,
    },
  ],
  sales: [
    {
      event: "Online management agreements are ready for countersigning",
      name: "agreementsCountersign",
      email: true,
      mobilePush: false,
    },
  ],
  clientExperience: [
    {
      event:
        "Someone tries to activate an online portal account with unrecognized info",
      name: "unrecgnizdActivtionAttmpt",
      email: true,
      mobilePush: false,
    },
    {
      event: "Move out notices or finalize move outs are submitted",
      name: "moveOutFinalized",
      email: true,
      mobilePush: false,
    },
    {
      event:
        "Residents purchase a FolioGuard Renters Insurance policy or upload insurance details",
      name: "rentersInsurancActvty",
      email: true,
      mobilePush: false,
    },
  ],
  notes: [
    {
      event: "When mentioned in a note",
      name: "noteMentions",
      email: true,
      mobilePush: true,
    },
  ],
};
